export default "__VITE_ASSET__23f84b1b__"